import { Button } from "src/elements";
import { useTranslation } from "src/i18n";
import { useNavigation } from "src/utils/navigation";
import { pages } from "src/utils/pages";

interface Props {
  categoryId: number;
  isDisabled?: boolean;
}

/** Entry point to the Distribution Planner: one button per category card. */
export const DistributionButton = ({ categoryId, isDisabled }: Props) => {
  const { navigate } = useNavigation();
  const { t } = useTranslation("distributionPlanner");

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      size="small"
      isDisabled={isDisabled}
      onClick={() => navigate(`${pages.distributionPlanner}?categoryId=${categoryId}`)}
    >
      {t("categoriesEntry.button")}
    </Button>
  );
};
